const footerNav = document.getElementById("footer_nav")

if (footerNav) {
    const footerMediaQuery = window.matchMedia("(min-width: 990px)")
    const footerDetails = footerNav.querySelectorAll("details")

    function handleResize(e) {
        if (footerDetails) {
            footerDetails.forEach((detail) => {
                if (e.matches) {
                    detail.setAttribute("open", "open")
                    detail.querySelector("summary").setAttribute("tabindex", "-1")
                } else {
                    detail.removeAttribute("open")
                    detail.querySelector("summary").removeAttribute("tabindex")
                }
            })
        }
    }

    footerMediaQuery.addListener(handleResize)

    handleResize(footerMediaQuery)
}

